<template>
    <vue-select :options="users"
                v-model="invitedUser.userId"
                label="name"
                :filterable="false"
                :reduce="user => user.id"
                @search="searchUser">
        <template slot="no-options">
            type name or email to search Users..
        </template>
        <template slot="option" slot-scope="option">
            <div class="d-center">
                <img v-if="option.social_avatar.avatar !== null"
                     class="img-avatar img-avatar-thumb img-avatar-rounded img-avatar32"
                     :src="option.social_avatar.avatar" alt="">
                <v-avatar :size="800" default-img="identicon" v-else
                          class="img-avatar img-avatar-thumb img-avatar-rounded img-avatar32"
                          :email="option.email"/>
                <strong class="p-2">{{ option.name }}</strong>
            </div>
        </template>
        <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
                <img v-if="option.social_avatar.avatar !== null"
                     class="img-avatar img-avatar-thumb img-avatar-rounded img-avatar32"
                     :src="option.social_avatar.avatar" alt="">
                <v-avatar :size="800" default-img="identicon" v-else
                          class="img-avatar img-avatar-thumb img-avatar-rounded img-avatar32"
                          :email="option.email"/>
                <strong class="p-2">{{ option.name }}</strong>
            </div>
        </template>
    </vue-select>
</template>

<script>
    import Avatar from 'vue-avatar';
    import GravatarImg from "vue-gravatar";
    import VueSelect from "vue-select";
    import {mapGetters} from 'vuex';

    export default {
        props: {
            invitedUser: {
                type: Object
            },

        },
        name: "user-dropdown",
        components: {
            Avatar,
            'v-avatar': GravatarImg,
            VueSelect
        },
        data() {
            return {
            }
        },
        computed: {
            ...mapGetters({users: 'getUsers'})
        },
        methods: {
            searchUser(string, loading) {
                loading(true);
                this.search(loading, string, this);
            },
            search: _.debounce((loading, searchString, vm) => {
                if (searchString.length > 2) {
                    axios.get('web/users/search?q=' + escape(searchString))
                        .then(res => {
                            vm.$store.commit('setUsers', res.data.data);

                        }).finally(() => loading(false));
                }
                loading(false);
            }, 350),
        }
    }
</script>

<style scoped>

</style>
